import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { ToastService } from "@shared/lib/services";
import {
  BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
  BRIEF_LIST_QUERY_KEY,
} from "../constants";

export function useAssignBriefPoc(briefId: string) {
  const {
    mutate: assignPricingPoc,
    isLoading: isAssigning,
    isSuccess: isAssigned,
  } = useMutation({
    mutationFn: (data: {
      briefInfluencerId: string[];
      assignedToUserId: string;
    }) =>
      BriefService.assignPricingPoc(
        data.briefInfluencerId,
        data.assignedToUserId
      ).catch(async (err) => {
        const responseBody = await err.response.json();
        ToastService.error(responseBody.msg);
        throw err;
      }),
    options: {},
    onSuccess: (c) => {
      c.invalidateQueries({
        queryKey: BRIEF_INFLUENCER_V2_SEARCH_QUERY_KEY,
        refetchType: "all", // Refetch all matching queries including inactive pages
      });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, briefId],
      });
    },
  });

  return {
    assignPricingPoc,
    isAssigning,
    isAssigned,
  };
}
